import { useRef, useCallback } from 'react';

export const useAudio = (src) => {
  const audioRef = useRef(null);

  const playAudio = useCallback(() => {
    if (audioRef.current) {
      // Check if audio is ready to play
      if (audioRef.current.readyState >= 2) {
        audioRef.current.currentTime = 0; // Reset to beginning
        audioRef.current.play().catch(error => {
          // Silently fail - don't show errors to user
        });
      } else {
        // Wait for audio to be ready
        const handleCanPlay = () => {
          audioRef.current.currentTime = 0;
          audioRef.current.play().catch(error => {
          });
          audioRef.current.removeEventListener('canplay', handleCanPlay);
        };
        audioRef.current.addEventListener('canplay', handleCanPlay);
      }
    }
  }, []);

  const AudioElement = () => (
    <audio
      ref={audioRef}
      src={src}
      preload="auto"
      style={{ display: 'none' }}
    />
  );

  return { playAudio, AudioElement };
};
